module.exports = __webpack_public_path__ + "img/BE0479608085.4b577a60.svg";